module.exports = __webpack_public_path__ + "img/ve.d42cc2f3.svg";